import axios from 'axios';

const getSystemFeaturesApi = async (token) => {
  try {
    const res = await axios.get('/system-features?type=1', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSystemFeaturesApi;
